import { images } from '.';

const guests = [
    {
        id: 1,
        image: images.eventGuest1,
        name: "Emma Clark",
        title: "AI Specialist",
        biography: "Emma Clark is a dynamic AI Specialist with a strong focus on intelligent automation and real-world AI implementation. With a solid background in applied machine learning, she helps organizations leverage AI for operational efficiency and innovation.",
        contacts: {
            phone: "555-123-4567",
            email: "emma.clark@example.com",
            website: "www.emmaclarkai.com",
            company: "CoreAI Systems",
            experience: "8+ Years in AI Solutions"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        achievements: [
            "Women in AI Leadership (2023)",
            "Top AI Contributor Award (2022)",
            "Innovative AI Project of the Year (2021)"
        ],
        skills: [
            { id: 1, title: "AI Automation", progress: 92 },
            { id: 2, title: "ML Deployment", progress: 88 },
            { id: 3, title: "Natural Language Processing", progress: 85 }
        ]
    },
    {
        id: 2,
        image: images.eventGuest2,
        name: "Liam Patel",
        title: "Data Scientist",
        biography: "Liam Patel is a skilled Data Scientist known for his ability to translate complex data into actionable insights. With a background in big data and predictive modeling, he supports AI teams in building data-driven strategies for smarter decisions.",
        contacts: {
            phone: "555-321-7890",
            email: "liam.patel@example.com",
            website: "www.liampateldata.com",
            company: "InsightAI Analytics",
            experience: "9+ Years in Data Science"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        achievements: [
            "Top 100 Data Scientists (2022)",
            "AI Data Innovation Award (2021)",
            "Best Predictive Model (2020)"
        ],
        skills: [
            { id: 1, title: "Predictive Modeling", progress: 94 },
            { id: 2, title: "Big Data Analysis", progress: 90 },
            { id: 3, title: "Data Visualization", progress: 87 }
        ]
    },
    {
        id: 3,
        image: images.eventGuest3,
        name: "Olivia Jones",
        title: "Cloud Engineer",
        biography: "Olivia Jones is a proficient Cloud Engineer with a focus on scalable infrastructure and secure cloud solutions. She has helped organizations modernize their systems using cloud-native technologies and automation practices.",
        contacts: {
            phone: "555-654-1122",
            email: "olivia.jones@example.com",
            website: "www.oliviajcloud.com",
            company: "NextGen CloudWorks",
            experience: "8+ Years in Cloud Engineering"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        achievements: [
            "Top Cloud Developer (2023)",
            "Cloud Excellence Award (2022)",
            "Certified Kubernetes Admin (2021)"
        ],
        skills: [
            { id: 1, title: "Cloud Architecture", progress: 93 },
            { id: 2, title: "DevOps Automation", progress: 89 },
            { id: 3, title: "Infrastructure Security", progress: 85 }
        ]
    },
    {
        id: 4,
        image: images.eventGuest4,
        name: "Noah Lee",
        title: "Tech Strategist",
        biography: "Noah Lee is a seasoned Tech Strategist known for bridging technology and business. He specializes in digital transformation, product innovation, and aligning tech initiatives with strategic goals.",
        contacts: {
            phone: "555-321-7788",
            email: "noah.lee@example.com",
            website: "www.noahstrategy.com",
            company: "VisionEdge Consulting",
            experience: "10+ Years in Tech Strategy"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        achievements: [
            "Innovation Leadership Award (2023)",
            "Top 100 Tech Influencers (2022)",
            "Digital Strategy Excellence (2021)"
        ],
        skills: [
            { id: 1, title: "Digital Strategy", progress: 94 },
            { id: 2, title: "Product Innovation", progress: 90 },
            { id: 3, title: "Business Alignment", progress: 87 }
        ]
    },
    {
        id: 5,
        image: images.eventGuest5,
        name: "Ava Khan",
        title: "Product Manager",
        biography: "Ava Khan is a dynamic Product Manager who excels at turning customer needs into successful tech solutions. Her expertise lies in product lifecycle management, agile workflows, and cross-functional team leadership.",
        contacts: {
            phone: "555-444-2233",
            email: "ava.khan@example.com",
            website: "www.avakhanpm.com",
            company: "NextGen Tech",
            experience: "8+ Years in Product Management"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        achievements: [
            "Product Leader of the Year (2023)",
            "Top Women in Tech (2022)",
            "Agile Excellence Award (2021)"
        ],
        skills: [
            { id: 1, title: "Product Strategy", progress: 92 },
            { id: 2, title: "Agile Development", progress: 89 },
            { id: 3, title: "Team Leadership", progress: 88 }
        ]
    },
    {
        id: 6,
        image: images.eventGuest6,
        name: "Ethan Roy",
        title: "Growth Hacker",
        biography: "Ethan Roy is a forward-thinking Growth Hacker known for driving rapid user acquisition and scaling startups through data-driven experiments and viral strategies. His skill set blends marketing innovation with tech savvy execution.",
        contacts: {
            phone: "555-222-7788",
            email: "ethan.roy@example.com",
            website: "www.ethanroygrowth.com",
            company: "ScaleX Labs",
            experience: "7+ Years in Growth Strategy"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        achievements: [
            "Top 10 Growth Hackers (2023)",
            "Startup Scale Award (2022)",
            "Best Digital Strategy (2021)"
        ],
        skills: [
            { id: 1, title: "User Acquisition", progress: 94 },
            { id: 2, title: "Conversion Funnels", progress: 91 },
            { id: 3, title: "A/B Testing", progress: 88 }
        ]
    },
    {
        id: 7,
        image: images.eventGuest7,
        name: "Sophia Park",
        title: "Innovation Lead",
        biography: "Sophia Park is an Innovation Lead recognized for spearheading breakthrough product strategies and fostering cross-functional innovation in tech organizations. She blends creativity with market insight to drive future-ready solutions.",
        contacts: {
            phone: "555-333-8899",
            email: "sophia.park@example.com",
            website: "www.sophiapark.io",
            company: "NextWave Tech",
            experience: "10+ Years in Innovation Strategy"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        achievements: [
            "Top 100 Innovators (2023)",
            "Innovation Excellence Award (2022)",
            "Women in Tech Leader (2021)"
        ],
        skills: [
            { id: 1, title: "Strategic Planning", progress: 93 },
            { id: 2, title: "Product Innovation", progress: 90 },
            { id: 3, title: "Design Thinking", progress: 87 }
        ]
    },
    {
        id: 8,
        image: images.eventGuest8,
        name: "Mason Kim",
        title: "Startup Mentor",
        biography: "Mason Kim is a seasoned startup mentor with deep expertise in early-stage business growth, investor relations, and scaling innovative ventures. He has guided dozens of tech startups from idea to market success.",
        contacts: {
            phone: "555-221-7744",
            email: "mason.kim@example.com",
            website: "www.masonmentor.com",
            company: "VentureCore Advisors",
            experience: "11+ Years in Startup Mentorship"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        achievements: [
            "Top Startup Mentor Award (2022)",
            "Tech Incubator Advisor of the Year (2021)",
            "Silicon Valley Mentor Circle (2019)"
        ],
        skills: [
            { id: 1, title: "Startup Strategy", progress: 92 },
            { id: 2, title: "Investor Pitching", progress: 88 },
            { id: 3, title: "Business Scaling", progress: 90 }
        ]
    }

];

export default guests;